angular.module('eatself').factory('authorization', ['$rootScope', '$state', 'principal',
	function($rootScope, $state, principal) {
		return {
			authorize: function() {
				return principal.identity()
					.then(function() {
						var isAuthenticated = principal.isAuthenticated();
						var roles = $rootScope.toState && $rootScope.toState.data && $rootScope.toState.data.roles;

						if (roles && roles.length > 0 && !principal.isInAnyRole(roles)) {
							if (isAuthenticated) {
								$state.go('accessdenied'); // user is signed in but not authorized for desired state
								return false;
							} else {
								// user is not authenticated. stow the state they wanted before you
								// send them to the signin state, so you can return them when you're done
								$rootScope.returnToState = $rootScope.toState;
								$rootScope.returnToStateParams = $rootScope.toStateParams;

								// now, send them to the signin state so they can log in
								$state.go('admin-login');
								return false;
							}
						}
						return true;
					});
			}
		};
	}
])
